<template>
  <wh-popup-dynamic-select
    :rules="rules"
    :extra-params="extraParams"
    search-name="search"
    name="cropBreed"
    :value="value"
    :show-picker.sync="pickerShow"
    :placeholder="placeholder"
    search-placeholder="输入关键字搜索"
    :data-src="traceTools.getControlAgriGoods.url"
    :label="label"
    history-key="plantCropBreed"
    :get-list-data="getCropListData"
  >
    <template #list="{list}">
      <div class="crop-list">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="crop-list-item wh-flex-between"
          :title="index"
          @click="selectCropBreed(item)"
        >
          <van-image height="40px" width="40px" fit="cover" :src="getCropThumbnail(item)" /> <span>{{ item.name }}</span>
        </div>
      </div>
    </template>
  </wh-popup-dynamic-select>
</template>

<script>
import traceTools from '@/api/modules/traceTools'
import WhPopupDynamicSelect from '@/components/public/WhPopupSelect/WhPopupDynamicSelect'
export default {
  name: 'CropBreedPopSelect',
  components: { WhPopupDynamicSelect },
  props: {
    value: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: '种类'
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '选择种养品种'
    }
  },
  data() {
    return {
      traceTools,
      pickerShow: false,
      extraParams: {
        search: undefined
      }
    }
  },
  methods: {
    getCropThumbnail(item) {
      if (item && item.thumbnail && item.thumbnail.length) {
        return item.thumbnail[0]
      }
    },
    selectCropBreed(item) {
      // console.log('item = ', item)
      this.pickerShow = false // 隐藏选择弹窗
      this.$emit('selectCropBreed', item)
    },
    getCropListData(res) {
      return res.data.pageInfo
    }
  }
}
</script>

<style lang='less' scoped>
.crop-list {
  .crop-list-item + .crop-list-item {
    border-top: 1px solid #e3e3e3;
  }
 .crop-list-item {
   padding: 10px;
   margin: 0 10px;
 }
}
</style>
